<div class="input-label time-calender">
  <p-calendar #calenderTime [(ngModel)]="time" styleClass="w-100" inputStyleClass="input-field" [readonlyInput]="true"
    [timeOnly]="true" [defaultDate]="minTime" [minDate]="minTime" [maxDate]="maxTime" [disabled]="isDisabled"
    inputId="timeonly" [placeholder]="placeholder"
    [icon]="'assets/themes/icons/headers/icon-calendar.svg'" (onSelect)="setTime($event)"></p-calendar>
  <img class="timer-icon cursor-text" [ngClass]="{'opacity-half': isDisabled}" src="assets/images/clock.svg" alt="calender" (click)="calenderTime.toggle()">
</div>
